App.SmChosenItemComponent = Em.Component.extend
  classNames: [ 'sm-chosen-item' ]

  text: (->
    if @get('labelTranslation')
      return Em.I18n.t(@get('labelTranslation') + '.' + @get('item'))

    Em.get( @get('item'), @get('labelPath'))
  ).property('item', 'item.currentState', 'labelPath', 'labelTranslation')

  actions:
    removeItem: ->
      @sendAction 'onRemove', @get('item')
      false
